import { CommonHelper } from 'src/utils/commonHelper';

const STORAGE_KEY = 'brand2chat_ticket_unread';
const EVENT_NAME = 'brand2chat:ticket-unread';
const BRAND_CHANGE_EVENT_NAME = 'brand2chat:brand-changed';

function normalizeBrandId(brandId) {
  const resolvedBrandId = Number(brandId || CommonHelper.GetCurrentBrandId() || 0);
  return Number.isFinite(resolvedBrandId) && resolvedBrandId > 0 ? String(resolvedBrandId) : '0';
}

function readCounts() {
  if (typeof window === 'undefined') return {};
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
    if (typeof parsed === 'number') {
      return Number.isFinite(parsed) && parsed > 0 ? { 0: parsed } : {};
    }
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (_error) {
    const legacyCount = Number(window.sessionStorage.getItem(STORAGE_KEY) || 0);
    return Number.isFinite(legacyCount) && legacyCount > 0 ? { 0: legacyCount } : {};
  }
}

export function getTicketUnreadCount(brandId) {
  if (typeof window === 'undefined') return 0;
  const count = Number(readCounts()[normalizeBrandId(brandId)] || 0);
  return Number.isFinite(count) && count > 0 ? count : 0;
}

function setTicketUnreadCount(count, brandId) {
  if (typeof window === 'undefined') return;
  const counts = readCounts();
  const key = normalizeBrandId(brandId);
  const nextCount = Math.max(0, Number(count) || 0);
  counts[key] = nextCount;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: { brandId: Number(key), count: nextCount },
  }));
}

export function incrementTicketUnreadCount(brandId) {
  setTicketUnreadCount(getTicketUnreadCount(brandId) + 1, brandId);
}

export function resetTicketUnreadCount(brandId) {
  setTicketUnreadCount(0, brandId);
}

export function addTicketUnreadListener(listener) {
  if (typeof window === 'undefined') return () => {};
  const handleChange = () => listener(getTicketUnreadCount());
  const handleBrandChange = () => listener(getTicketUnreadCount());
  window.addEventListener(EVENT_NAME, handleChange);
  window.addEventListener(BRAND_CHANGE_EVENT_NAME, handleBrandChange);
  return () => {
    window.removeEventListener(EVENT_NAME, handleChange);
    window.removeEventListener(BRAND_CHANGE_EVENT_NAME, handleBrandChange);
  };
}
